import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Loading, SERVER_ERROR } from 'commons';
import request from '../request';

import styles from './Password.module.css';

class Password extends Component {
  state = {
    loading: false,
    error: '',
    password: '',
    passwordStatus: 0 // 0=undefined, 1=ok, -1=error
  };

  handleChange = e => {
    this.setState({ password: e.target.value });
  };

  handleSubmit = async e => {
    e.preventDefault();

    const { email, requestId, action } = this.props;
    const { password } = this.state;

    this.setState({ loading: true });

    const formData = [
      `email=${encodeURIComponent(email)}`,
      `requestId=${encodeURIComponent(requestId)}`,
      `password=${encodeURIComponent(password)}`,
      `action=${action}`
    ];

    try {
      const res = await request('/session/login', formData.join('&'));

      if (res.status >= 300 || res.status < 200) {
        this.setState({ loading: false, ...SERVER_ERROR });
        return;
      }

      this.setState({ passwordStatus: 1 });
      const data = await res.json();

      if (data.error) {
        switch (data.error) {
          case 401: // Password incorrect
            this.setState({ passwordStatus: -1, loading: false });
            break;
          default:
            this.props.onUpdateSession({ action: 'request' });
        }
      }

      if (data.action === 'success') {
        // Login process is done
        document.location.href = data.redirectUri;
      } else {
        // Login process needs to continue to another step
        this.props.onUpdateSession({
          action: data.action,
          requestId: data.requestId,
          email: data.email
        });
      }
    } catch (error) {
      this.setState({ loading: false, ...SERVER_ERROR });
    }
  };

  goBackHome = e => {
    e.preventDefault();
    this.props.onUpdateSession({ action: 'login' });
  };

  renderErrorMessage = () => {
    const { passwordStatus } = this.state;

    if (passwordStatus === -1) {
      return <div className="message-error">The credentials you supplied were incorrect</div>;
    }
    return null;
  };

  render() {
    const { email } = this.props;
    const { loading, error, password } = this.state;

    if (loading) return <Loading />;
    if (error.length > 0) return <div className="boxed-container"><div className="margin-top-large">{error}</div></div>;

    return (
      <div className="boxed-container">
        <div className="margin-bottom-large">
          <div className={styles.welcome}>Welcome</div>
          <div className={styles.email}>{email}</div>
        </div>
        {this.renderErrorMessage()}
        <form className="form-fixed-width-small form-animated" onSubmit={this.handleSubmit}>
          <div className="potdemiel">
            <input
              id="hiddenEmail"
              value={email}
              type="email"
              aria-hidden="true"
              autoCorrect="off"
              autoComplete="off"
              tabIndex="-1"
              readOnly
            />
          </div>
          <div className="margin-bottom-large">
            <input
              id="password"
              autoFocus
              name="password"
              placeholder="Password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={this.handleChange}
            />
            <div className={styles.helpForgotPassword}>
              <Link className={styles.link} to={`/forgot-password?email=${encodeURIComponent(email)}`}>
                Forgot Password
              </Link>
            </div>
          </div>
          <div>
            <input className="btn" type="button" onClick={this.goBackHome} value="BACK" />
            <input className="btn" type="submit" value="NEXT" />
          </div>
        </form>
      </div>
    );
  }
}

export default Password;
